import { render, staticRenderFns } from "./prescripteur_list.vue?vue&type=template&id=24dae01c&"
import script from "./prescripteur_list.vue?vue&type=script&lang=js&"
export * from "./prescripteur_list.vue?vue&type=script&lang=js&"
import style0 from "./prescripteur_list.vue?vue&type=style&index=0&id=24dae01c&prod&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports